export default {
  ASSIGNMENTS_POLLING_INTERVAL_MS: 10 * 1000,
};
